// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__r4PvV","dragIcon":"SortableItem_dragIcon__Ff7aE","disabled":"SortableItem_disabled__rt_D_"};